import { clipRangeCountQuery } from "../queries";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { ClientApiFeatureSubPathParams } from "@visioni/a3s-client-api";
import type { ClipRangeCount, CountClipsInRangeQueryParams } from "../../client-messages/clips";

export type UseClipRangeCountOptions = ClientApiFeatureSubPathParams &
  CountClipsInRangeQueryParams & {
    enabled?: boolean;
  };

/**
 * Fetch how many clips a camera holds within an absolute time range.
 *
 * Counts the same clips {@link useClips} lists — including lazy ones, which
 * exist as metadata before their video is ever uploaded — without paying for
 * the signed URLs a list would carry.
 */
export function useClipRangeCount(options: UseClipRangeCountOptions): UseQueryResult<ClipRangeCount> {
  const apiConfig = useApiConfig();
  const { enabled = true, startTime, endTime, source, ...pathParams } = options;

  const queryParams = { startTime, endTime, source };

  return useQuery({
    ...clipRangeCountQuery(apiConfig, pathParams, queryParams),
    enabled,
    select: (response) => response.data,
  });
}
